import React from 'react';

export const MobileNavigationContext = React.createContext<(() => void) | null>(null);
